import axios from 'axios';
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

export default {
  data() {
    return {
      totalFiles:  0,
      currentFile: 0,
    };
  },
  mounted() {
    console.log('CanvasFileUploadMixin mounted');
  },
  methods: {
    handleDragOver(event) {
      event.preventDefault();
    },
    async onUploadFile(e) {
      EventBus.$emit('showHideLoader', true);
      const target = e.dataTransfer;
      e.preventDefault();
      try {
        const files = target.files;
        if (files.length === 0) { EventBus.$emit('showHideLoader', false); return; }
        this.totalFiles = files.length;
        this.$store.commit('activeProduct/updateTotalUploadFiles', this.totalFiles);
        this.$store.commit('activeProduct/updateCurrentUploadFile', 0);
        console.log(typeof files)
        console.log(files)
        for (let i = 0; i < files.length; i++) {
          const file          = files[i];
          const type          = file.type.split('/');
          const fileName      = file.name;
          const fileSize      = file.size / 1024 / 1024;
          const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
          const isValidPDF    = type[1] === 'pdf';
          const isValidImage  = type[0] === 'image' && ['png', 'svg', 'jpg', 'jpeg'].includes(fileExtension);
          if (fileExtension == 'mp4') {
            if (fileSize > 50) {
              alert(`"${fileName}" is too large. Max allowed size is 50MB.`);
              const currentFile = i + 1;
              this.$store.commit('setCurrentUploadFile', currentFile);
              return; // Skip this file
            }
            this.postVideo(file);
          } else if (isValidPDF || isValidImage) {

            if (fileSize > 20) {
              alert(`"${fileName}" is too large. Max allowed size is 20MB.`);
              const currentFile = i + 1;
              this.$store.commit('setCurrentUploadFile', currentFile);
              return; // Skip this file
            }
            let fileToUpload = file;

            if (isValidPDF) {
              fileToUpload = await this.handlePDFUpload(file);
            }

            this.getBase64(fileToUpload, type[1]);
          } else {
            alert(`"${fileName}" is not a valid image/pdf. Allowed: .png, .svg, .jpg, .jpeg, .pdf .mp4`);
            this.$store.commit('activeProduct/updateCurrentUploadFile', this.$store.getters['activeProduct/getCurrentUploadFile'] + 1);
            const totalUploFiles    = this.$store.getters['activeProduct/getTotalUploadFiles'];
            const currentUploadFile = this.$store.getters['activeProduct/getCurrentUploadFile'];
            if (totalUploFiles === currentUploadFile) {
              EventBus.$emit('showHideLoader', false);
              this.$store.commit('activeProduct/updateTotalUploadFiles', 0);
              this.$store.commit('activeProduct/updateCurrentUploadFile', 0);
            }
          }
        }
        target.value = ''; // Clear input after all
      } catch (ex) {
        EventBus.$emit('showHideLoader', false);
        alert(ex.message);
        // this.loaderToggle = false;
      }
    },
    formatFileName(name) {
      return name
          .replace(/[^a-zA-Z0-9._-]/g, '_')
          .replace(/_+/g, '_');
    },
    getBase64(file, fileType) {
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId             = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : '{e8c7bbd8-b238-4553-b8b9-6801df82a92d}';

      const regextext = /[/\\?%*:|"<>@!~`()&• ]/g;
      regextext.test(file.name) && (file =  new File([file.slice(0, file.size, file.type)], file.name.replaceAll(regextext, '-'), { type: file.type }));
      const imageData                 = {
        Id:                   '',
        Name:                 file.name,
        DefaultImageUrl:      '',
        ImageType:            'Image',
        CropOption:           'NotSpecified',
        ImageThumbnailPath:   '',
        ImageThumbnailPathV2: '',
      };
      const imageExtension            = imageData.Name.substring(imageData.Name.lastIndexOf('.') + 1, imageData.Name.length);
      const imageNameWithOutExtension = imageData.Name.substring(0, imageData.Name.lastIndexOf('.'));
      const reqFormData               = new FormData();
      reqFormData.append('file', file);
      const headers = {
        'Content-Type': 'text/plain',
      };

      const serverURL = (this.isSubdomain(this.$store.getters.getBMCInstance)) ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      axios.post(`https://${serverURL}.com/webservices/UploadImages.ashx?userId=${userId}`, reqFormData, { headers })
        .then(async (res) => {
          const url                         = res.data;
          imageData.Id                      = url.substring(url.lastIndexOf('#') + 1, url.length);
          const returnedName                = url.substring(url.lastIndexOf('/') + 1, url.lastIndexOf('#'));
          imageData.previousDefaultImageUrl = `https://www.bankmarketingcenter.com/temp/uploadedimages/${imageData.Id
          }${imageNameWithOutExtension}-resized-600.${imageExtension}#${imageData.Id}`;
          imageData.ImageThumbnailPath      = imageExtension === 'svg' ? url : `https://www.bankmarketingcenter.com/thumbnails/80-80--temp-uploadedimages-${
            returnedName}`;
          imageData.ImageThumbnailPathV2    = imageData.ImageThumbnailPath;
          imageData.DefaultImageUrl         = url.substring(0, url.lastIndexOf('#'));
          EventBus.$emit('AddImageNewImageToMyGalleryImages', imageData);
          setTimeout(() => {
            // console.log(this.currentFile, this.totalFiles );
            EventBus.$emit('onAddingNewObjectImage', imageData);
            // if (this.currentFile === this.totalFiles) {
              // EventBus.$emit('showHideLoader', false);
              // this.$store.commit('toggleIsAddNewImageModal');
              // this.currentFile = 0;
              // this.totalFiles  = 0;
            // }
          }, 100);
        })
        .catch((e) => {
          // EventBus.$emit('showHideLoader', false);
          throw new Error(e.message);
        })
        .finally(() => {
          // this.currentFile = this.currentFile + 1;
        });
    },
    async handlePDFUpload(fileToUpload) {
      const reqFormData = new FormData();
      reqFormData.append('pdf', fileToUpload);
      const headers      = {
        'Content-Type': 'text/plain',
      };
      const res          = await axios.post('https://pdf-processing.bankmarketingcenter.com/node/pdf2svg/pdf2svg?return-svg=true', reqFormData, { headers, responseType: 'blob' })
        .catch((err) => {
          EventBus.$emit('showHideLoader', false);
          throw new Error(err.response.statusText);
        });
      const fileBlob     = await res.data;
      const rand         = Math.random().toString(36).slice(2, 7);
      const fileToReturn = new File([fileBlob], `pdf-${rand}.svg`, { lastModified: 1534584790000 });
      return Promise.resolve(fileToReturn);
    },
    async postVideo(file) {
      const self               = this;
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId             = newUrlSearchParams.has('userId') ? newUrlSearchParams.get('userId') : '21d29854-fb88-45e6-9a12-b1f4e6c67d45';
      const videoData          = {
        Id:           '',
        Name:         file.name,
        videoDetails: {
          duration: null,
          height:   null,
          width:    null,
          mimeType: '',
        },
        AlternativeVideoUrlsResVersion: [],
      };

      const reqFormData = new FormData();
      reqFormData.append('file', file);
      const headers   = {
        'Content-Type': 'text/plain',
      };
      const serverURL = (this.isSubdomain(this.$store.getters.getBMCInstance)) ? this.$store.getters.getBMCInstance : `www.${this.$store.getters.getBMCInstance}`;
      axios.post(`https://${serverURL}.com/WebServices/UploadVideos.ashx?userId=${userId}`, reqFormData, { headers })
        .then(async (response) => {
          if (response.data && !this.modalHidden) {
            videoData.videoDetails.VideoSourceUrl       = response.data.VirtualPath;
            videoData.videoDetails.videoHighRes         = response.data.HighResUrl;
            videoData.videoDetails.audio                = response.data.AudioUrl;
            videoData.videoDetails.duration             = response.data.Duration;
            videoData.videoDetails.width                = response.data.Width;
            videoData.videoDetails.height               = response.data.Height;
            videoData.videoDetails.ThumbnailVirtualPath = response.data.ThumbnailVirtualPath;

            videoData.AlternativeVideoUrlsResVersion.push(response.data);
            setTimeout(() => {
              EventBus.$emit(ApplicationEventTypes.Video.ADD_NEW_VIDEO_ON_CANVAS, videoData);
              EventBus.$emit('SetPageVideoLength', videoData.videoDetails.duration);
              self.$store.commit('setDisplayAddVideoModal', false);
              this.$store.commit('setIsVideoModel', false);
              this.$store.commit('activeProduct/updateIsVideoMoodOn', true);
            }, 10);
          } else {
            alert(response.data.message);
            EventBus.$emit('showHideLoader', false);
          }
        })
        .catch((e) => {
          console.log(e);
          self.isLoading = false;
          alert('File can not be uploaded');
          // EventBus.$emit('AddNewVideoOnCanvas', videoData);
          EventBus.$emit('showHideLoader', false);
        });
    },
    isSubdomain(url) {
      url         = `https://${url}.com`;
      const regex = new RegExp(/^([a-z]+\:\/{2})?([\w-]+\.[\w-]+\.\w+)$/);
      return !!url.match(regex); // make sure it returns boolean
    },
  },
};
